<template>
    <div>
        <div class="container_global">
            <div v-if="!loaded" class="container_preload">
                <div class="roulette"></div>
            </div>
            <template v-else-if="loaded">
                <v-volet v-if="$mq != 'mobile'" type="chronologie"></v-volet>
                <v-volet v-if="$mq != 'mobile'" type="mots_clefs"></v-volet>
                <v-volet v-if="$mq != 'mobile'" type="localisations"></v-volet>
                <v-volet v-if="$mq != 'mobile'" type="acteurs"></v-volet>
                <v-volet type="interventions"></v-volet>
            </template>
            <v-volet-bas></v-volet-bas>
        </div>
    </div>
</template>

<script>

    import Volet from './Volet.vue';
    import VoletBas from './VoletBas.vue';
    import { state } from '../main.js';
    import { url_liste_objets } from '../variables.js';

    export default {
        data() {
            return {
                loaded: false
                // vue_principale: state.vue_principale,
                // modal_ajout: state.modal_ajout,
                // modal_objet: state.modal_objet
            }
        },

        components: {
            'v-volet': Volet,
            'v-volet-bas': VoletBas
        },

        created: function() {
            this.chercherObjets();
            var hasOurCookie = this.hasCookie("architecturePrecarites");
            //enable cookie popup
            if(hasOurCookie == true || hasOurCookie == "true"){
                document.body.setAttribute("data-overlay",false);
            }else{
                document.body.setAttribute("data-overlay",true);
                this.setCookie("architecturePrecarites","true",30);
            }
            // disable cookie popup
            //document.body.setAttribute("data-overlay",true);
        },

        methods: {
            hasCookie(cookiename){
                let result = false;
                let cname = cookiename + "=";
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');
                for(let i = 0; i < ca.length; i++) {
                    let c = ca[i].split("=")[0].replace(" ", '');
                    if(c == cookiename){
                        result = true;
                    }else{
                        result = false;
                    }
                }
                return result;
            },
            setCookie(cname, cvalue, exdays) {
                const d = new Date();
                d.setTime(d.getTime() + (exdays*24*60*60*1000));
                let expires = "expires="+ d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            },
            chercherObjets() {
                this.axios.get(url_liste_objets).then((response) => {
                    let fiches = response.data.fiches;
                    for (var i = 0; i < fiches.length; i++) {
                        fiches[i].survol_actif = false;
                        this.$set(state.fiches, i, fiches[i]);
                    }
                    let mots_clefs = response.data.mots_clefs;
                    for (var i = 0; i < mots_clefs.length; i++) {
                        mots_clefs[i].survol_actif = false;
                        this.$set(state.mots_clefs, i, mots_clefs[i]);
                    }
                    let fonctions = response.data.fonctions;
                    for (var i = 0; i < fonctions.length; i++) {
                        this.$set(state.fonctions, i, fonctions[i]);
                        // FONCTIONS PAR ID
                        let id = fonctions[i].id;
                        let nom = fonctions[i].fonction;
                        this.$set(state.fonctions_par_id, id, nom);
                    }
                    let acteurs = response.data.acteurs;
                    for (var i = 0; i < acteurs.length; i++) {
                        this.$set(state.acteurs, i, acteurs[i]);
                        // ACTEURS PAR ID
                        let id = acteurs[i].id;
                        this.$set(state.acteurs_par_id, id, acteurs[i]);
                    }
                    this.loaded = true;
                    // this.$set(state.fiches, response.data.fiches);
                });
            }
        }
    };
</script>

<style>
    .container_global {
        height: 100vh;
    }
</style>
